import axios from 'axios'
import TokenService from '../services/storage.service'

export default {
    namespaced: true,
    state: {
        token: null,
        user: null
    },
    getters: {
        authenticated (state) {
            return state.token && state.user
        },
        user (state) {
            return state.user
        }
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_USER(state, user) {
            state.user = user
        }
    },
    actions: {
        async signIn({ dispatch }, credentials ) {
            let response = await axios.post('auth/loginvendor', credentials)
            TokenService.saveUser(credentials.email)
            dispatch('attempt', response.data.access_token)
        },
        async signCode({ dispatch }, credentials ) {
            let response = await axios.post('auth/logincodevendor', credentials)
            dispatch('attempt', response.data.access_token)
        },
        async attempt( { commit, state }, token ) {
            if(token) {
                commit('SET_TOKEN', token)
            }

            if(!state.token) {
                return
            }

            try {
                let response = await axios.post('auth/vendorme')
                commit('SET_USER', response.data)
            } catch (error) {
                //this.$store.dispatch('setConnected', false)
            }
        },
        signOut({ commit }) {
            return axios.post('auth/logout').then(() => {
                commit('SET_TOKEN', null)
                commit('SET_USER', null)
            })
        }
    }
}